export default __webpack_public_path__ + "static/media/30M.91780b7a.jpeg";